import React from "react";
import "./SiteDomainBanner.css";

const PRINT_BUDDY_URL = "https://ziniz.online/PrintBuddy";

/**
 * Permanent notice: service home is ziniz.online/PrintBuddy (static bar, clickable link).
 */
const SiteDomainBanner = () => (
  <aside className="site-domain-banner" role="status" aria-live="polite">
    <div className="site-domain-banner__inner">
      <span className="site-domain-banner__label">New home</span>
      <span className="site-domain-banner__text">
        Community Print Buddy is now served at{" "}
        <a
          href={PRINT_BUDDY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="site-domain-banner__link"
        >
          ziniz.online/PrintBuddy
        </a>
        — use this link to place requests.
      </span>
    </div>
  </aside>
);

export default SiteDomainBanner;
